import React, {Component} from "react";
import {Backdrop, CircularProgress, withStyles} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import axios from "axios";
import {withSnackbar} from 'material-ui-snackbar-provider';
import {withTranslation} from 'react-i18next';
import customConstants from "Constants";
import GaugeChart from 'react-gauge-chart'

const styles = theme => ({
    wrapper: {
        position: "relative",
        backgroundColor: '#fff'
    },

    buttonProgress: {
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12
    }
});

const chartStyle = {
    height: 150,
    marginTop: 50
}



class UserUsage extends Component {
    state = {
        waitingUserList: [],
        loading: false,
        value: 0,
        maxValue: 0,
    }

    componentDidMount() {
        this.setState({loading: true});
        // get request will be for approval list
        axios.get(customConstants.API_URL + "/reporting/charging")
            .then((res) => {
                try {
                    console.log(res)
                    this.setState({maxValue: res.data.packageSize})
                    this.setState({value: res.data.count})
                    this.setState({loading: false});
                } catch (e) {
                    console.log(e)
                    this.props.snackbar.showMessage(this.props.t("The operation could not be performed due to an error."), 'error');
                    this.setState({loading: false});
                }
            }).catch((e) => {
            this.props.snackbar.showMessage(this.props.t("The operation could not be performed due to an error."), 'error');
            this.setState({loading: false});
        })
    }




    render() {


        return (
            <section className="section_wrapper">
                <div className="section_header">
                    <h2>{this.props.t("Usage Statistics")}</h2>
                </div>
                {(this.state.loading === true) ?
                    <Backdrop style={{
                        zIndex: 999,
                        color: '#fff'
                    }} open={this.state.loading}><CircularProgress
                        color="secondary"/></Backdrop> : null}
                {this.state.maxValue > 0 && this.state.value > 0 ? <div style={{display:'inline-block'}}><GaugeChart id="gauge-chart1" style={chartStyle} type="semicircle"
                                                                                                                     nrOfLevels={this.state.maxValue}
                                                                                                                     arcsLength={[0.3, 0.5, 0.2]}
                                                                                                                     colors={['#5BE12C', '#F5CD19', '#EA4228']}
                                                                                                                     percent={this.state.value *100 /this.state.maxValue / 100 }
                                                                                                                     arcPadding={0.02}
                                                                                                                   />
                    <div style={{textAlign: 'center'}}>{this.state.value} / {this.state.maxValue} </div>
                </div> : null}


            </section>
        );
    }
}

export default withTranslation()(withStyles(styles, {withTheme: true})(withSnackbar()(withRouter(
    UserUsage
))));
